import Header from 'components/Header'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Avatar, Chip, LinearProgress, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getStatusColor } from 'utils'

export default function PersonHeader({ applicationRecord }) {
  const { applicationId } = useParams()
  const { t } = useTranslation()
  const list = useSelector(state => state.application?.studentApplications?.list || [])
  const ids = list.map(item => item.id)
  const currentId = Number(applicationId)
  const { district, campus } = useSelector(state => state.session)
  const navigate = useNavigate()
  const basePath = '/admission/application-list'
  const { '*': tabName } = useParams()
  const types = useSelector(state => state.lookup.types)?.filter(item => item.category === 'applicationStatus')

  if (!applicationRecord) return <LinearProgress />

  const currentSchool = applicationRecord?.applicationSchools?.find(s => s.school?.id === campus?.schoolId) ?? applicationRecord?.applicationSchools?.[0]

  const getInitials = (firstName, lastName) => {
    const first = firstName?.[0] || '' 
    const last = lastName?.[0] || ''
    return (first + last).toUpperCase()
  }

  const { firstName, lastName } = applicationRecord || {}

  const page = dir => {
    if (!ids) return
    const idx = ids.indexOf(currentId)
    const n = idx + dir

    if (n >= 0 && n < ids.length) {
      navigate([basePath, ids[n], tabName].filter(Boolean).join('/'), { replace: true })
    }
  }

  return (
    <Header
      avatar={
        <Avatar sx={{ bgcolor: 'primary.main', width: 100, height: 100, fontSize: '50px' }}>
          {getInitials(firstName, lastName)}
        </Avatar>
      }
      prev={() => page(-1)}
      next={() => page(1)}
      title={`${firstName || ''} ${lastName || ''}`}
      close
    >
      <Typography variant='body1'>
        {t('Grade Applying')}: {applicationRecord?.studentGr?.name} | {t('Application ID')}: {applicationRecord?.id}
      </Typography>
      {!district?.isServiceProvider && (
        <Stack direction='row' spacing={1} alignItems='center' pt={0.5}>
          <Typography variant="body1" >
            {t('Status')}:
          </Typography>
          <Chip
            label={currentSchool?.status ? (types?.find(type => type?.code === currentSchool?.status)?.name || t('-')) : t('-')}
            color={getStatusColor(currentSchool?.status)}
            size='small'
          />
        </Stack>
      )}
    </Header>
  )
}
